export function Location({ address, suburb }) {
  return (
    <div className={`property-card__location`}>
      {address && address + `, `}
      {suburb}
    </div>
  );
}
